/* eslint-disable import/prefer-default-export */
export const PAYMENT_NATURES = [
  'C/R', 'C/CHQ', 'Chèque', 'Effet', 'Bon de caisse', 'Reçu bancaire', 'C/R', 'C/CHQ', 'C/EFF',
];
export const BANKS = [
  'Attijari Wafa Bank', 'Banque Populaire', 'Crédit du Maroc', 'BMCE', 'CIH', 'Société Générale', 'BMCI', 'Crédit Agricole', 'Umnia Bank', 'Bank of Africa', 'Barid BANK', 'Bank Assafa', 'Al akhdar BANK', 'CFG Banque', 'UMB',
];
export const Fields = [
  {
    type: 'autocomplete',
    id: 'clientCode',
    label: 'Client',
    listName: 'clients',
    filter: (option, value) => option
      ?.code.toLowerCase().includes(value?.toLowerCase()) || option
      ?.name.toLowerCase().includes(value?.toLowerCase()),
    optionLabel: (option) => (option ? `${option?.code}: ${option.name}` : option),
    width: 204,
  },
  {
    type: 'date-range',
    id: 'date',
    label: 'Date début',
    label2: 'Date fin',
    defaultValue: { start: null, end: null },
  },
  /* {
    type: 'autocomplete',
    id: 'type',
    label: 'Nature du règlement',
    listName: 'paymentNatures',
    filter: (option, value) => option
      ?.toLowerCase().includes(value?.toLowerCase()),
    optionLabel: (option) => option,
    width: 204,
  }, */
  /* {
    type: 'autocomplete',
    id: 'bank',
    label: 'Banque',
    listName: 'banks',
    filter: (option, value) => option
      ?.toLowerCase().includes(value?.toLowerCase()),
    optionLabel: (option) => option,
    width: 204,
  }, */
  {
    type: 'autocomplete',
    id: 'status',
    label: 'Libellé',
    listName: 'paymentStatusList',
    filter: (option, value) => option.label
      ?.toLowerCase().includes(value?.toLowerCase()),
    optionLabel: (option) => option.label,
    width: 204,
  },
  {
    type: 'date-range',
    id: 'echeanceDate',
    label: 'Echéance début',
    label2: 'Echéance fin',
    defaultValue: { start: null, end: null },
  },
  {
    type: 'autocomplete',
    id: 'nePasVerse',
    label: 'Flag',
    listName: 'verseList',
    filter: (option, value) => option
      ?.toLowerCase().includes(value?.toLowerCase()),
    optionLabel: (option) => option,
    width: 104,
  },
];
